export default __webpack_public_path__ + "static/media/icon-error-404.78f07255.svg";